var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8142 3.05353H12.1268C13.5318 3.05353 14.6602 4.19285 14.6602 5.59353V7.88686C14.6602 8.06442 14.566 8.22867 14.4128 8.31837C12.8065 9.25862 10.7409 9.84207 8.49691 9.91833V11.1179C8.49691 11.3941 8.27305 11.6179 7.99691 11.6179C7.72077 11.6179 7.49691 11.3941 7.49691 11.1179V9.91855C5.2509 9.84323 3.18859 9.25945 1.58091 8.31837C1.42767 8.22867 1.3335 8.06442 1.3335 7.88686V5.58686C1.3335 4.18192 2.47282 3.05353 3.8735 3.05353H5.17966C5.30396 2.08347 6.13317 1.33325 7.13691 1.33325H8.85691C9.86065 1.33325 10.6899 2.08347 10.8142 3.05353ZM6.19685 3.05353H9.79696C9.68545 2.63886 9.30658 2.33325 8.85691 2.33325H7.13691C6.68723 2.33325 6.30837 2.63886 6.19685 3.05353ZM3.8735 4.05353C3.02084 4.05353 2.3335 4.73847 2.3335 5.58686V7.59487C3.85417 8.42072 5.82261 8.92486 7.98062 8.92686C7.98602 8.92668 7.99146 8.9266 7.99691 8.9266C8.00228 8.9266 8.00762 8.92668 8.01295 8.92685C10.1687 8.92383 12.1406 8.41977 13.6602 7.59484V5.59353C13.6602 4.74087 12.9752 4.05353 12.1268 4.05353H3.8735Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9771 10.1599C13.2532 10.1599 13.4771 10.3838 13.4771 10.6599V13.9932C13.4771 14.2694 13.2532 14.4932 12.9771 14.4932C12.7009 14.4932 12.4771 14.2694 12.4771 13.9932V10.6599C12.4771 10.3838 12.7009 10.1599 12.9771 10.1599Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8105 12.3267C10.8105 12.0505 11.0344 11.8267 11.3105 11.8267H14.6439C14.92 11.8267 15.1439 12.0505 15.1439 12.3267C15.1439 12.6028 14.92 12.8267 14.6439 12.8267H11.3105C11.0344 12.8267 10.8105 12.6028 10.8105 12.3267Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34822 10.2845C2.32748 10.0091 2.08744 9.80271 1.81207 9.82346C1.53671 9.8442 1.3303 10.0842 1.35105 10.3596L1.47706 12.0325C1.58211 13.4203 2.73858 14.4934 4.1303 14.4934H9.49137C9.76752 14.4934 9.99137 14.2695 9.99137 13.9934C9.99137 13.7172 9.76752 13.4934 9.49137 13.4934H4.1303C3.26208 13.4934 2.53991 12.8237 2.47421 11.957L2.34822 10.2845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPortfolio);
export default __webpack_public_path__ + "static/media/new_portfolio.30ab5296698138fc4b69a9931107166d.svg";
export { ForwardRef as ReactComponent };